import { render } from "./SchemaBuilder.vue?vue&type=template&id=32798d11&scoped=true"
import script from "./SchemaBuilder.vue?vue&type=script&lang=js"
export * from "./SchemaBuilder.vue?vue&type=script&lang=js"

import "./SchemaBuilder.vue?vue&type=style&index=0&id=32798d11&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32798d11"]])

export default __exports__